import { getYear } from "@/lib/helpers/common";
import styles from "./designIdeaLongBody.module.css";
import { useState } from "react";

export function DesignIDeaLongBody() {
  const [readMore, setReadMore] = useState(false);
  return (
    <section className={`${styles.readMore} bgGray`}>
      <div className="container">
        <div
          className={`${styles.lowerContnt} ${readMore ? styles.fullHeight : null
            }`}
        >
          <h2>Explore the Oasis of Home Interior Design Ideas</h2>
          <p>
            Explore home designing ideas that are comfortable and practical. Whether it&apos;s a modular wardrobe design or a TV unit design, here you can find the right mix of style and function! Our skilled team takes pride in understanding your needs and making your home super fun. Not only do we renovate your home, but we also handle interior decoration. For instance, if your Kid&apos;s room designs need places to play as well as study, then we are here to make it happen while keeping it well decorated. Apply now, and let&apos;s turn your home design ideas into reality. {" "}
          </p>
          <h2>Why Choose Interior Company for Your Home Interiors?</h2>
          <p>
            When thinking about your next indoor house design project, Interior Company is your trusted choice. Not only do we focus on making your space look nice, but also be useful. Our team cares about your space, so we make sure to deliver the best of our work. Whether it&apos;s your master bedroom designs or just a redo for a party, with us, you can know in and out about your project details. Choose Interior Company for your next home interior decoration project, and we&apos;ll help make your ideas real.
          </p>
          <h2>Interior Design Ideas: Small Homes to Villas</h2>
          <p>
            Let&apos;s explore how interior design works its magic in various homes. Here, every home gets a chance to get creative with design!
          </p>
          <h3>Compact Urban Spaces</h3>
          <p>
            In 2 BHK houses or studio apartments home interior design must focus on the organisation and management of the overall space. From shades to furniture, everything must be efficient. Whether it&apos;s your bedroom or living room interior design, our team ensures that the furniture of the room will do more than one job. Also, mirror placement and selection of the right colours will be taken care of in our home interior ideas!
          </p>
          <h3>Mid Luxury Spaces</h3>
          <p>
            In larger homes like condos, houses or 3 BHK apartments, the focus of interior home design is to incorporate comfort and style. Open layouts, high-quality materials, and a mix of indoor and outdoor spaces will be the base internal design of the home. To make it fancy, standout pieces of furniture, and home decor for both inside and balcony designs will be incorporated.
          </p>
          <h3>
            Embracing Luxury Spaces
          </h3>
          <p>
            Villas, penthouses and bungalows are like a canvas for luxury living. Big spaces allow house interior design to flow freely without any restrictions. You can also get your home decorated in a theme. From modular kitchen designs to out-of-the-box bathroom designs, everything is possible in your fancy space. {" "}
          </p>
          <h2>
            Latest Interior Design Trends to Explore in {getYear()}
          </h2>
          <p>
            Home design is changing! Every year, people are trying new things. Let&apos;s look at the big {getYear()} house inner design trends.
          </p>
          <h3>Going Green</h3>
          <p>People want home design interior design to be closer to nature. They use eco-friendly stuff like wooden furniture and smart tech like solar charging equipment to upgrade the home.</p>
          <h3>Big, Bold Tiles</h3>
          <p>Floors and walls are getting attention this year. These interior design ideas come with tiles that are big and unique, with cool patterns. They&apos;re like art for your floors.</p>
          <h3>Forever WFH</h3>
          <p>Since more folks work from home, home offices are a big deal now. People are making cool workspaces with efficient home interiors that stick around.</p>
          <h3>Classic with a Twist</h3>
          <p>Old-fashioned home interior design ideas are coming back but with a modern twist. This design mixes old and new in your space.</p>
          <h3>Let the Sunlight In</h3>
          <p>Sun is an essential part of our life, this year make it a part of your new home interior design. Add big windows and mirrors to make homes bright.</p>
          <h2>FAQs</h2>
          <h3 className={styles.faqsReadmore}>
            What does an interior designer do?
          </h3>
          <p>
            An interior designer enhances the aesthetic and functional aspects of indoor spaces. This is done by selecting colours, furniture and other aspects of the interior tailored to client&apos;s preferences.{" "}
          </p>
          <h3 className={styles.faqsReadmore}>
            What are the 7 elements of interior design?
          </h3>
          <span>
            <p>
              Here are seven elements of interior design -
            </p>
            <ul>
              <li>1. Space</li>
              <li>2. Form</li>
              <li>3. Line</li>
              <li>4. Light </li>
              <li>5. Colour </li>
              <li>6. Pattern  </li>
              <li>7. Texture </li>
            </ul>
          </span>
          <h3 className={styles.faqsReadmore}>
            What is interior work?
          </h3>
          <p>
            Interior work is the process of improving the inside of buildings by optimising the layouts of the architecture. Interior designers, professionals in this field, work with clients to understand preferences and needs related to colour, theme, furniture and more. The aim is to make spaces, whether homes or offices, more comfortable.
          </p>
          <h3 className={styles.faqsReadmore}>
            How to design the interior of your home?
          </h3>
          <p>
            To make your home look nice inside, first, decide how you want it to feel and set a budget. Look at the room to see how much space and light it has. Pick colours you like and choose furniture that fits the room. Arrange the furniture so it&apos;s easy to move around. Add personal things like photos and make sure the lighting is good. Think about if you want to do it yourself or get help from a professional. Make sure it feels like your home and fits your style and budget.
          </p>
          <h3 className={styles.faqsReadmore}>
            What is the difference between home design and interior design?
          </h3>
          <p>
            Home design plans how houses look and function outside. They work on structures with homeowners and builders. Interior design, on the other hand, focuses on making the inside good and working well. It involves choosing colours, and furniture, and arranging things for your rooms.
          </p>
          <h3 className={styles.faqsReadmore}>
            What are full home interiors?
          </h3>
          <p>
            Full home interiors mean redo of all the rooms in the house. It&apos;s not just one room – it&apos;s everything, like the living room, bedrooms, kitchen, and bathrooms. The goal here is to make sure everything fits together and reflects the style of the person living there. So, when someone says &quot;full home interiors,&quot; they mean making the entire house feel just right.
          </p>
          <h3 className={styles.faqsReadmore}>
            What are the 7 principles of interior design?
          </h3>
          <span>
            <p>
              The seven main principles of interior design are
            </p>
            <ul>
              <li>1. Balance</li>
              <li>2. Harmony</li>
              <li>3. Rhythm</li>
              <li>4. Proportion and scale</li>
              <li>5. Emphasis</li>
              <li>6. Contrast</li>
              <li>7. Details</li>
            </ul>
            {" "}
          </span>
          <h3 className={styles.faqsReadmore}>
            What is the importance of interior design in the home?
          </h3>
          <p>
            Interior design in your home is vital as it makes everything nice. It&apos;s not just about colours and furniture – it&apos;s about creating a place that suits your style and needs. When your home is well-designed, it&apos;s also organised and comfy.
          </p>  <h3 className={styles.faqsReadmore}>
            What are the 5 styles of interior design?
          </h3>
          <span>
            <p>
              Here are five common interior designs -
            </p>
            <ul>
              <li>1. Traditional </li>
              <li>2. Modern </li>
              <li>3. Transitional </li>
              <li>4. Electic  </li>
              <li>5. Mid-Century Modern </li>
            </ul>
          </span>
          <h3 className={styles.faqsReadmore}>
            What are the best home designs?
          </h3>
          <p>
            The best home design is the one you like the most. Some people like modern and simple designs, while others prefer classic and cosy. There are also trendy designs and ones with less stuff (minimalist). It&apos;s all about what makes you feel comfortable and happy in your home!
          </p>
        </div>
        <p className={styles.link} onClick={() => setReadMore(!readMore)}>
          Read {readMore ? "Less" : "More.."}
        </p>
      </div>
    </section>
  );
}
